import _ from 'lodash';
import config from '../../../package.json';

import { _get, resolveLocalizedText } from '../../../utils';
import { getAppModuleConfig } from '../../../selectors/configSelectors';
import { EmmaTncConfig } from '../types/EmmaTncConfig';
import { deepLinkFormat } from '../../../../src/utils/WebUtils';
import { getLanguage } from '../../../../src/selectors/userSelectors';

export const PROFILE_API_EMMA_TNC_CONFIG_NAME = 'emma-tnc';

export const getTncUrls = (state: {}) => {
  const result: { [id: string]: string } = {};

  getAppModuleConfig<EmmaTncConfig>(
    state,
    PROFILE_API_EMMA_TNC_CONFIG_NAME,
  ).terms.forEach((t) => {
    const label = t.labels.find((l) => !!l.deepLink);
    if (label && label.deepLink.query && label.deepLink.query.url) {
      result[t.id] = resolveLocalizedText(label.deepLink.query.url);
    }
  });

  return result;
};

export const getSecurityAwarenesssLink = (state: {}) => {
  const dl = getAppModuleConfig<any>(
    state,
    'emma-profile.securityAwarenessDeepLink',
  );

  return deepLinkFormat(dl, getLanguage()).query.url;
};
